import Icon from './Icon';

const ShareTwitter = ({ className }) => (
  <Icon name="share-twitter" className={className} viewBox="0 0 31 31">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1300.000000, -161.000000)">
        <g transform="translate(1145.000000, 158.000000)">
          <g transform="translate(155.000000, 3.000000)">
            <g>
              <ellipse
                fill="#4FABF0"
                cx="15.5"
                cy="15.6692247"
                rx="15.5"
                ry="15.2964399"
              />
              <path
                d="M23.4078182,11.9823191 C22.8554545,12.2066669 22.2702121,12.3670478 21.6520909,12.4634617 C22.2702121,12.0787331 22.7577576,11.5011766 22.9850909,10.7956862 C22.3998485,11.1164479 21.7497879,11.3732427 21.0349091,11.5011766 C20.4825455,10.9236201 19.7019091,10.5704114 18.8245152,10.5704114 C17.1016667,10.5704114 15.7357879,11.9183522 15.7357879,13.5861277 C15.7357879,13.8104755 15.7686667,14.0672703 15.8334848,14.2600981 C13.2651818,14.1636842 11.0228485,12.9446043 9.49445455,11.1164479 C9.23424242,11.5651435 9.07172727,12.0787331 9.07172727,12.6238426 C9.07172727,13.6825416 9.6250303,14.6133068 10.4376061,15.1584163 C9.95006061,15.1259693 9.46251515,14.9980354 9.07172727,14.7736877 L9.07172727,14.8052076 C9.07172727,16.2810823 10.1125758,17.5001622 11.5103939,17.7884769 C11.2501818,17.8533709 10.9899697,17.8848908 10.6978182,17.8848908 C10.5024242,17.8848908 10.3070303,17.8848908 10.1445152,17.8209239 C10.535303,19.0400038 11.6729091,19.905875 13.0049697,19.938322 C11.9650606,20.7402263 10.6320606,21.2213688 9.20230303,21.2213688 C8.94209091,21.2213688 8.68187879,21.2213688 8.45454545,21.1898489 C9.81948485,22.0557201 11.412697,22.5368627 13.1684242,22.5368627 C18.7916364,22.5368627 21.8803636,17.9488578 21.8803636,13.9393364 L21.8803636,13.5546078 C22.4646667,13.1049851 22.9850909,12.5923226 23.4078182,11.9823191"
                fill="#FFFFFE"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);

export default ShareTwitter;
